import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiUrl } from '../../config/api';

interface EmailReportRequest {
  config_id: number;
  report_type: 'daily' | 'weekly' | 'monthly';
  custom_recipients?: string[];
}

interface EmailReportResponse {
  success: boolean;
  message: string;
  report_type: string;
  config_id: number;
}

interface EmailTestRequest {
  config_id: number;
  test_recipients: string[];
}

interface EmailTestResponse {
  success: boolean;
  message: string;
  recipients: string[];
}

export const emailApi = createApi({
  reducerPath: 'emailApi',
  baseQuery: fetchBaseQuery({
    baseUrl: getApiUrl('/api/v1/email'),
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as any).auth.token;
      console.log('Email API - Token:', token ? 'Present' : 'Missing');
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['EmailReport'],
  endpoints: (builder) => ({
    sendEmailReport: builder.mutation<EmailReportResponse, EmailReportRequest>({
      query: (data) => ({
        url: '/send-report',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['EmailReport'],
    }),
    testEmail: builder.mutation<EmailTestResponse, EmailTestRequest>({
      query: (data) => ({
        url: '/test-email',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useSendEmailReportMutation,
  useTestEmailMutation,
} = emailApi;
